<div class="af-user-company-container"
     *ngIf="dataItems().length > 1"
     [style.width.px]="controlWidth()">

  <span *ngIf="heading()" [ngClass]="headingCssClass()">{{heading()}}</span>

  <kendo-dropdownlist [data]="filteredDataItems()"
                      [loading]="loading()"
                      [value]="selectedItem()"
                      [filterable]="true"
                      textField="companyName"
                      valueField="companyId"
                      [valuePrimitive]="false"
                      class="user-company-dl"
                      (valueChange)="onValueChange($event)"
                      (selectionChange)="onSelectionChange($event)"
                      (filterChange)="onFilterChange($event)">
    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <ng-container *ngIf="dataItem.isMain; else notMain">
        <span class="item-isMain">{{ dataItem.companyName }}</span>
      </ng-container>
      <ng-template #notMain>
        <ng-container>
          <span>{{ dataItem.companyName }}</span>
        </ng-container>
      </ng-template>
    </ng-template>

  </kendo-dropdownlist>
</div>
